import {Component, Injector, ViewChild} from '@angular/core';
import {SearchFieldDirective} from './search-field.directive';
import {SearchField} from '@twpub/core/models';
import {ComponentCategory, SessionParam} from '@twpub/core/enums';
import {BaseWrapperComponent} from '@twpub/shared/components/base';
import {DictionaryService} from '@twpub/core/services';

@Component({
  selector: 'pub-search-field-wrapper',
  template: '<ng-template pubSearchField></ng-template>',
  standalone: true,
  imports: [SearchFieldDirective]
})
export class SearchFieldWrapperComponent extends BaseWrapperComponent<SearchField> {
  override compCategory = ComponentCategory.SearchField;
  protected override changesTriggers: SessionParam[] = [SessionParam.SEARCH_TERM, SessionParam.SOURCE_LANGS];
  private dictionaryService: DictionaryService;

  constructor(injector: Injector) {
    super(injector);
    this.dictionaryService = injector.get(DictionaryService);
  }

  @ViewChild(SearchFieldDirective, {static: true}) pubSearchField!: SearchFieldDirective

  override createComponent(): SearchField {
    const comp = super.createComponent();
    comp.searchFor.subscribe((str: string) => this.sharedStateService.setSearchTerm(str))
    this.update();
    return comp;
  }

  override update() {
    super.update((comp) => {
      comp.searchTerm = this.sharedStateService.getSearchTerm();
      const langCode = this.sharedStateService.getSourceLangs()[0];
      const selectedDictIds = this.sharedStateService.getDictionaryIds();
      this.dictionaryService.getLanguages(selectedDictIds).subscribe(langs => {
        comp.rtl = langs.find(l => l.code === langCode)?.rtl || false;
      })
    })
  }

  getViewContainerRef() {
    return this.pubSearchField.viewContainerRef;
  }
}
